import React from 'react';

const ProductPopup = ({ videoUrl, onClose }) => {
  if (!videoUrl) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
      <div style={{ position: 'relative', width: '90vw', maxWidth: 600, background: '#fff', borderRadius: 8, padding: 16 }}>
        {/* Move button after the iframe and use a higher zIndex */}
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
          <iframe
            src={videoUrl}
            title="Product Video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}
          />
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: 8,
              right: 12,
              fontSize: 22,
              background: '#FF4500',
              color: '#fff',
              border: 'none',
              borderRadius: '50%',
              width: 32,
              height: 32,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px #0002',
              zIndex: 2 // Ensure button is above the iframe
            }}
            aria-label="Close"
          >×</button>
        </div>
      </div>
    </div>
  );
};

export default ProductPopup;
